import { getAggregatedInternalBucketResolution } from 'api_old/NewActual/nextApi';
import {
  all,
  call,
  delay,
  put,
  SagaReturnType,
  select,
  takeLatest,
} from 'redux-saga/effects';
import * as R from 'remeda';
import { internalHourActions } from 'store/aggregated/internalHour';
import { userSelectors } from 'store/glue/user';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';
import { timeUtility } from 'utility';

import * as realtimeActions from './actions';
import * as constants from './constants';

function* startSelectDaySaga(
  action: ActionType<typeof realtimeActions.startSelectDay>,
) {
  // don't want to load on sync functionallity
  const { selectedDay } = action.payload;
  yield put(realtimeActions.setSelectedDay(selectedDay));

  function* saga() {
    yield delay(300);
    const bearerToken: ReturnType<typeof userSelectors.bearerToken> =
      yield select(userSelectors.bearerToken);
    if (!R.isDefined(bearerToken)) return;
    const tenantId: ReturnType<typeof userSelectors.tenantId> = yield select(
      userSelectors.tenantId,
    );
    if (!R.isDefined(tenantId)) return;

    // We want to compare right?
    const previousDay = timeUtility.step({
      timeDate: selectedDay,
      step: 'previous',
      stepSize: 'day',
    });

    const internalHourDomain: SagaReturnType<
      typeof getAggregatedInternalBucketResolution
    > = yield call(getAggregatedInternalBucketResolution, {
      companyId: tenantId,
      bearerToken,
      resolution: 'Zone',
      bucketResolution: 'Hour',
      dates: [previousDay, selectedDay],
    });
    yield put(internalHourActions.setDomain(internalHourDomain));
  }
  yield call(sagaWrapper, { saga, type: action.type });
}

export function* watcher() {
  yield all([takeLatest(constants.START_SELECT_DAY, startSelectDaySaga)]);
}
